import { render } from "./DynamicComponentContextualMenu.vue.js?vue&type=template&id=48f436e3&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicComponentContextualMenu.vue?vue&type=template&id=48f436e3&scoped=true"
import script from "./DynamicComponentContextualMenu.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicComponentContextualMenu.vue?vue&type=script&lang=js"
export * from "./DynamicComponentContextualMenu.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicComponentContextualMenu.vue?vue&type=script&lang=js"

import "./DynamicComponentContextualMenu.vue.scss?vue&type=style&index=0&id=48f436e3&lang=scss&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicComponentContextualMenu.vue?vue&type=style&index=0&id=48f436e3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f436e3"],['__file',"src/SharedWeb/scripts/dynamic-component-editor/components/DynamicComponentContextualMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48f436e3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48f436e3', __exports__)) {
    api.reload('48f436e3', __exports__)
  }
  
  module.hot.accept("./DynamicComponentContextualMenu.vue.js?vue&type=template&id=48f436e3&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicComponentContextualMenu.vue?vue&type=template&id=48f436e3&scoped=true", () => {
    api.rerender('48f436e3', render)
  })

}


export default __exports__